import React from "react";
import { styles } from "./../Style";
import { useState } from "react";


export function SetCard(props) {
    return (
        <img style={(() => {return props.selected == "no" ? styles.CardStyle : styles.SelectedCardStyle})()} src={process.env.PUBLIC_URL + "setCards/setCard" + (props.n <= 80 && props.n >= 0 ? props.n : -1) + ".png"} alt={"setcard"+props.n} onClick={() => props.handleClick(props.pos)} />
    );
}
